'use client';

import React__default from 'react';

var HeartFillIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.color, color = _c === void 0 ? '#4D8CFF' : _c;
    return (React__default.createElement("svg", { width: width, height: width, viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        React__default.createElement("g", { clipPath: 'url(#clip0_7199_169040)' },
            React__default.createElement("path", { d: 'M7.4541 2.8335C4.4416 2.8335 2 5.2751 2 8.2876C2 13.5313 8.08248 18.5417 10.9242 20.7729C10.9269 20.7751 10.9296 20.7773 10.9323 20.7795C10.9518 20.7947 10.9782 20.8165 10.9974 20.8315L10.999 20.8299C11.2873 21.0478 11.6386 21.166 12 21.1668C12.3619 21.1664 12.7138 21.0481 13.0026 20.8299V20.8315C13.0082 20.8271 13.0165 20.8213 13.0221 20.8169C13.0264 20.8135 13.0325 20.8089 13.0368 20.8055C13.0422 20.8007 13.0477 20.7958 13.0531 20.7909C15.8859 18.5676 22 13.5438 22 8.2876C22 5.2751 19.5584 2.8335 16.5459 2.8335C13.6667 2.8335 12 5.3335 12 5.3335C12 5.3335 10.3333 2.8335 7.4541 2.8335Z', fill: color })),
        React__default.createElement("defs", null,
            React__default.createElement("clipPath", { id: 'clip0_7199_169040' },
                React__default.createElement("rect", { width: '20', height: '20', fill: 'white', transform: 'translate(2 2)' })))));
};
var HeartFillIcon$1 = React__default.memo(HeartFillIcon);

export { HeartFillIcon$1 as default };
//# sourceMappingURL=HeartFillIcon.js.map
